export enum ApiKeys {
  DashboardExperience = 'activate/customerengagement/dashboard/v2',
  OrderDeliveryDetails = 'activate/customerengagement/dashboard/order_delivery_details/v1',
}

export const DASHBOARD_EXPERIENCE_CACHE_KEY = ApiKeys.DashboardExperience
